import TermsAI from './TermsAI';

export default TermsAI;
